import { api } from 'app/api';

export const getMebiConn = ({ hspId, ptMpiKey, mebiBaseUrl, rcorgNo }) => {
  return async () => {
    const params = {};
    if (mebiBaseUrl) params.mebiBaseUrl = mebiBaseUrl;
    if (rcorgNo) params.rcorgNo = rcorgNo;

    return await api.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/mebi-conn/${hspId}/${ptMpiKey}`, {
      params,
    });
  };
};
